import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { villageInfo, importantContacts, adminContact } from '../data/mock';
import { MapPin, Phone, Facebook, Youtube, Shield } from 'lucide-react';

const Footer = () => {
  const { t, getText, language } = useLanguage();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Village Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center">
                <span className="text-white font-bold">ਮ</span>
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">{getText(villageInfo.name)}</h3>
                <p className="text-amber-400 text-sm">{getText(villageInfo.district)}</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              {getText(villageInfo.tagline)}
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-amber-600 flex items-center justify-center transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-amber-600 flex items-center justify-center transition-colors">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm hover:text-amber-400 transition-colors">{t('about')}</Link>
              <Link to="/directory" className="text-sm hover:text-amber-400 transition-colors">{t('directory')}</Link>
              <Link to="/services" className="text-sm hover:text-amber-400 transition-colors">{t('services')}</Link>
              <Link to="/events" className="text-sm hover:text-amber-400 transition-colors">{t('events')}</Link>
              <Link to="/grievance" className="text-sm hover:text-amber-400 transition-colors">{t('grievance')}</Link>
            </div>
          </div>

          {/* Important Contacts */}
          <div>
            <h4 className="text-white font-semibold mb-4">
              {language === 'pa' ? 'ਮਹੱਤਵਪੂਰਨ ਸੰਪਰਕ' : 'Important Contacts'}
            </h4>
            <div className="flex flex-col gap-3">
              {importantContacts.slice(0, 3).map((contact) => (
                <div key={contact.id} className="flex items-start gap-2">
                  <Phone className="h-4 w-4 text-amber-500 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-xs text-gray-500">{getText(contact.title)}</p>
                    <p className="text-sm">{contact.name}</p>
                    <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="text-xs text-amber-400 hover:underline">
                      {contact.phone}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Village Location & Admin */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('contact')}</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-amber-500 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  {getText(villageInfo.name)}, {getText(villageInfo.tehsil)}<br />
                  {getText(villageInfo.district)}, {getText(villageInfo.state)} - {villageInfo.pincode}
                </span>
              </div>
              
              {/* Website Admin */}
              <div className="mt-4 p-3 bg-gray-800/50 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <Shield className="h-4 w-4 text-amber-500" />
                  <span className="text-xs text-gray-400">{getText(adminContact.role)}</span>
                </div>
                <p className="text-sm font-medium text-white">{adminContact.name}</p>
                <a 
                  href={`tel:${adminContact.phone.replace(/\s/g, '')}`}
                  className="text-amber-400 text-sm hover:underline"
                >
                  {adminContact.phone}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 text-center">
          <p className="text-sm text-gray-500">
            © 2025 {getText(villageInfo.name)} Village. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
